module.exports = {
  SET_GLOBAL_START_DATE: 'SET_GLOBAL_START_DATE',
  SET_GLOBAL_END_DATE: 'SET_GLOBAL_END_DATE',
  RESET_GLOBAL_START_DATE: 'RESET_GLOBAL_START_DATE',
  RESET_GLOBAL_END_DATE: 'RESET_GLOBAL_END_DATE',
};
